const timelines = document.querySelectorAll(".Timeline_Line");

timelines.forEach((timeline) => {
  const inner = timeline.querySelector(".Timeline_Inner");
  const anchors = timeline.querySelectorAll(".Timeline_Anchor");

  /*
  gsap
    .timeline({
      scrollTrigger: {
        trigger: timeline,
        start: "top center+=100px",
        end: "bottom center+=100px",
        scrub: true,
      },
    })
    .to(inner, {
      ease: "linear",
      height: "100%",
    });

  anchors.forEach((a) => {
    ScrollTrigger.create({
      trigger: a,
      start: () => `top center+=100px`,
      end: () => `bottom center+=100px`,
      onEnter: () => a.classList.add("Passed"),
      onLeaveBack: () => a.classList.remove("Passed"),
    });
  });
  */

  const scrollTimeline = new ScrollTimeline(timeline, onScroll);

  function onScroll(ratio){
    let virtualRatio = Math.min(ratio / 0.8, 1);

    inner.style.height = `${virtualRatio * 100}%`;

    anchors.forEach((a, index) => {
        if (virtualRatio >= (1 + (index*2)) / (anchors.length * 2)) {
            a.classList.add("Passed");
        } else {
            a.classList.remove("Passed");
        }
    });
  }

});